<mat-tab-group
  onsip-mat-tab-table
  class="onsip-tab-group-full-height"
  mat-align-tabs="start"
  mat-stretch-tabs="false"
  (selectedIndexChange)="onSelectedIndexChange($event)"
>
  <mat-tab label="{{ 'ONSIP_I18N.PARKING_LOT_SETTINGS' | translate }}">
    <ng-template matTabContent>
      @if ((settingsView | async) === 'view') {
      <onsip-parking-lot-settings-view
        [parkLot]="parkLot"
        (editPanel)="toggleParkLotSettingsPanel('edit')"
      ></onsip-parking-lot-settings-view>
      } @else {
      <onsip-parking-lot-settings-edit
        [parkLot]="parkLot"
        [parkChannelPrice]="parkChannelPrice"
        (editPanel)="toggleParkLotSettingsPanel('view')"
      ></onsip-parking-lot-settings-edit>
      }
    </ng-template>
  </mat-tab>

  <mat-tab label="{{ 'ONSIP_I18N.PARKING_LOT_CALLER_SETTINGS' | translate }}">
    <ng-template matTabContent>
      @if ((callerSettingsView | async) === 'view') {
      <onsip-caller-settings-view
        [parkLot]="parkLot"
        (editPanel)="toggleCallerSettingsPanel('edit')"
      ></onsip-caller-settings-view>
      } @else {
      <onsip-caller-settings-edit
        [parkLot]="parkLot"
        (editPanel)="toggleCallerSettingsPanel('view')"
      ></onsip-caller-settings-edit>
      }
    </ng-template>
  </mat-tab>
</mat-tab-group>
